var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entity-list"},[_c('entity-list-legend'),_c('div',{staticClass:"fos-open-scouts"},_vm._l((_vm.entities),function(e){return _c('div',{key:e.id},[_c('entity',{key:e.id,attrs:{"entity":e}})],1)})),_c('entity-footer')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d211b4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/entities/List.vue
// module id = null
// module chunks = 